module.exports = __webpack_public_path__ + "img/logo_lalamove.711d6988.png";